import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEsMx from '../locales/es-MX/common.json';
import authEsMx from '../locales/es-MX/auth.json';
import tenantEsMx from '../locales/es-MX/tenant.json';
import errorsEsMx from '../locales/es-MX/errors.json';
import ventasEsMx from '../locales/es-MX/ventas.json';
import reconciliationEsMx from '../locales/es-MX/reconciliation.json';
import integrationEsMx from '../locales/es-MX/integration.json';
import storesEsMx from '../locales/es-MX/stores.json';
import transferNotesEsMx from '../locales/es-MX/transferNotes.json';
import reconciliationEngineEsMx from '../locales/es-MX/reconciliationEngine.json';

await i18n.use(initReactI18next).init({
    lng: 'es-MX',
    fallbackLng: 'es-MX',
    defaultNS: 'common',
    ns: ['common', 'auth', 'tenant', 'errors', 'ventas', 'reconciliation', 'integration', 'stores', 'transferNotes', 'reconciliationEngine'],
    resources: {
        'es-MX': {
            common: commonEsMx,
            auth: authEsMx,
            tenant: tenantEsMx,
            errors: errorsEsMx,
            ventas: ventasEsMx,
            reconciliation: reconciliationEsMx,
            integration: integrationEsMx,
            stores: storesEsMx,
            transferNotes: transferNotesEsMx,
            reconciliationEngine: reconciliationEngineEsMx,
        },
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
